import React, { useState } from "react";
import "./subscription.scss";
import {
  element_icons,
  logoutmodal,
  months1_icon,
  months2_icon,
  months3_icon,
} from "../../assets/icons";
import { Button } from "../../component/form";
import CustomModal from "../../component/modal/CustomModal";
import ButtonLoader from "../../component/buttonLoader";
import { IoClose } from "react-icons/io5";

const Subscription = () => {
  const [show, setShow] = useState(false);

  return (
    <div className="wrapper_profile_details wrapper_subscription">
      <div className="land_tittle">
        <h2 className="title">My Subscription</h2>
      </div>
      <div className="wrapper_details">
        <div className="container">
          <div className="wrap_details">
            <h4>Your Plans</h4>
            <ul>
              <li onClick={() => setShow(true)}>
                <div className="wrap_icons">
                  <img src={months1_icon} alt="month-icon" />
                  <div className="wrap_subs_details">
                    <p>1 month Plan</p>
                    <span>Unlimited Consultations</span>
                  </div>
                </div>
                <img src={element_icons} alt="element-icon" />
              </li>
            </ul>
            <h4>Other Available Plans</h4>
            <ul>
              <li>
                <div className="wrap_icons">
                  <img src={months1_icon} alt="month-icon" />
                  <div className="wrap_subs_details">
                    <p>1 month Plan</p>
                    <span>Unlimited Consultations</span>
                  </div>
                </div>
                <img src={element_icons} alt="element-icon" />
              </li>
              <li>
                <div className="wrap_icons">
                  <img src={months2_icon} alt="month-icon" />
                  <div className="wrap_subs_details">
                    <p>2 month Plan</p>
                    <span>Unlimited Consultations</span>
                  </div>
                </div>
                <img src={element_icons} alt="element-icon" />
              </li>
              <li>
                <div className="wrap_icons">
                  <img src={months3_icon} alt="month-icon" />
                  <div className="wrap_subs_details">
                    <p>3 month Plan</p>
                    <span>Unlimited Consultations</span>
                  </div>
                </div>
                <img src={element_icons} alt="element-icon" />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <CustomModal
        show={show}
        className={"logoutModal wrapper_plans_subscription"}
        closeButton={false}
      >
        <span className="close_button" onClick={() => setShow(false)}>
          <IoClose />
        </span>

        <div className="wrap_log_modal">
          <p className="heading_p">1 Month Plan</p>
          <ul>
            <p>16 Days Remaining</p>
            <li>
              <span>Plan Start Date</span>
              <span className="date">19 February, 2025</span>
            </li>
            <li>
              <span>Plan End Date</span>
              <span className="date">19 February, 2025</span>
            </li>
          </ul>
          <ul>
            <p className="sub_title">Details:</p>
            <li>
              <span>Plan Duration</span>
              <span className="date">30 Days</span>
            </li>
            <li>
              <span>Number of Consultations</span>
              <span className="date">Unlimited</span>
            </li>
            <li>
              <span>Plan Price</span>
              <span className="date">Rs. 500.00</span>
            </li>
          </ul>
          <div className="button_wrap">
            <Button>Purchase Plan</Button>
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default Subscription;
